import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';
import { getSectionLayoutZonesInfo } from '../../../../selectors/layout';
import { addModule } from '../../../../actions/layout';
import { Props } from './ZoneGroup';

type StateProps = Pick<Props, 'isOwner' | 'zones'>;
type DispatchProps = Pick<Props, 'addModule'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  props
) => {
  return {
    isOwner: isCurrentUserProfileOwner(state),
    zones: getSectionLayoutZonesInfo(state, props.section),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  addModule: (zone, moduleType, position) =>
    ownProps.section &&
    dispatch(
      addModule({ section: ownProps.section, zone, moduleType, position })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps);
